import { useContext, useEffect } from 'react'
import { ArtboardContext } from '../../board/context'

const useDurationSync = (frameCount: number) => {
    const { autoDuration, fps, layers, setDuration } = useContext(ArtboardContext)

    useEffect(() => {
        if (autoDuration && layers.length > 0) {
            const layerDurations = layers.map((layer) => layer.getDuration())
            const maxDuration = Math.max.apply(Math, layerDurations)

            if (isNaN(maxDuration)) {
                setDuration(0)
            } else {
                setDuration(Math.round(maxDuration * 100) / 100)
            }
        }
    }, [autoDuration, fps, frameCount, layers.length])
}

export default useDurationSync
